'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringTemplate = require('string-template');

var _stringTemplate2 = _interopRequireDefault(_stringTemplate);

var _utils = require('../../../utils');

var _tpl = require('./tpl');

var _tpl2 = _interopRequireDefault(_tpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Progress = function () {
  function Progress(elContainer, value) {
    _classCallCheck(this, Progress);

    var progress = (100 * value).toFixed(2);

    this.element = (0, _utils.createElement)((0, _stringTemplate2['default'])(_tpl2['default'], { progress: progress }));
    this.elReached = this.element.querySelector('.reached');
    this.elIndicator = this.element.querySelector('.indicator');
    this.totalValue = null;
    elContainer.appendChild(this.element);

    this.onChange = function () {};
  }

  Progress.prototype.init = function init() {
    this.bindEvents();
  };

  Progress.prototype.bindEvents = function bindEvents() {
    var _this = this;

    this.element.addEventListener('mouseup', function (ev) {
      _this._isMoving = false;
      var progress = _this.getValue(ev);
      _this.setProgress(progress);
      _this.onChange(progress);
    });

    this.element.addEventListener('mousedown', function (ev) {
      _this._isMoving = true;

      // 注意禁用默认，防止元素被拖拽
      ev.preventDefault();
      ev.stopPropagation();
    });
    this.element.addEventListener('mouseleave', function (ev) {
      if (!_this._isMoving) {
        return;
      }

      _this._isMoving = false;
      var progress = _this.getValue(ev);
      _this.setProgress(progress);
      _this.onChange(progress);
    });

    this.element.addEventListener('mousemove', function (ev) {
      if (!_this._isMoving) {
        return;
      }
      _this.setProgress(_this.getValue(ev), true);
    });
  };

  Progress.prototype.setProgress = function setProgress(value, isForce) {
    if (!isForce && this._isMoving) {
      return;
    }
    var showVal = (100 * (0, _utils.getValid)(value, 0, 1)).toFixed(2);
    this.elReached.style.width = showVal + '%';
    this.elIndicator.style.left = showVal + '%';
  };

  Progress.prototype.getValue = function getValue(ev) {
    var rect = this.element.getBoundingClientRect();
    return (0, _utils.getValid)((ev.clientX - rect.left) / rect.width, 0, 1);
  };

  return Progress;
}();

exports['default'] = Progress;
module.exports = exports['default'];